import { ajaxController } from './controller/AjaxController'

export interface ShiftBandDto {
  shift: string
  shiftNumber: number
  startTime: string
  durationHours: number
}

export type MovementCarriedBy = 'DiggerLoader' | 'PlantModel' | 'Plant'
export type MovementTimeEntry = 'None' | 'Hour' | 'Time'

export interface MovementScreenConfig {
  carriedBy: MovementCarriedBy
  timeEntry: MovementTimeEntry
}

export interface MovementEntryConfigResponse {
  rehandle: MovementScreenConfig
  crushing: MovementScreenConfig
}

export interface ShiftBandsResponse {
  timeZone: string
  shiftBands: ShiftBandDto[]
}

export interface OperationsConfigResponse {
  nodVarianceThresholdHours: number
}

export interface PlantsConfigResponse {
  allowedShiftHours: number[]
}

class ConfigAjax {
  async getShiftBands() {
    return ajaxController.get<ShiftBandsResponse>('/Config/shift-bands', {})
  }

  async getOperationsConfig() {
    return ajaxController.get<OperationsConfigResponse>('/Config/operations', {})
  }

  async getPlantsConfig() {
    return ajaxController.get<PlantsConfigResponse>('/Config/plants', {})
  }

  async getMovementEntryConfig() {
    return ajaxController.get<MovementEntryConfigResponse>('/Config/movement-entry', {})
  }
}

export const configAjax = new ConfigAjax()
